var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-menu-win-wire",class:{ 'header-menu-win-wire--red': _vm.shouldNotify },on:{"click":_vm.handleClick}},[_c('IconWinWire',{staticClass:"header-menu-win-wire__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }